import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  products: [],
  allProducts: [],
  adminProducts: [],
  featuredProducts: [],
  bestSellers: [],
  product: null,
  totalCount: 0,
  totalPages: 0,
  currentPage: 1,
  error: null,
  success: false,
};

export const productReducer = createReducer(initialState, {
  productCreateRequest: (state) => { state.isLoading = true; },
  productCreateSuccess: (state, action) => {
    state.isLoading = false;
    state.product = action.payload;
    state.success = true;
  },
  productCreateFail: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
    state.success = false;
  },

  getAllProductsRequest: (state) => { state.isLoading = true; },
  getAllProductsSuccess: (state, action) => {
    state.isLoading = false;
    state.allProducts = action.payload.products || action.payload;
    state.totalCount = action.payload.totalCount || 0;
    state.totalPages = action.payload.totalPages || 0;
    state.currentPage = action.payload.currentPage || 1;
  },
  getAllProductsFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  getAllProductsShopRequest: (state) => { state.isLoading = true; },
  getAllProductsShopSuccess: (state, action) => {
    state.isLoading = false;
    state.products = action.payload;
  },
  getAllProductsShopFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  getAdminProductsRequest: (state) => { state.isLoading = true; },
  getAdminProductsSuccess: (state, action) => {
    state.isLoading = false;
    state.adminProducts = action.payload.products;
    state.totalCount = action.payload.totalCount;
    state.totalPages = action.payload.totalPages;
  },
  getAdminProductsFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  deleteProductRequest: (state) => { state.isLoading = true; },
  deleteProductSuccess: (state, action) => {
    state.isLoading = false;
    state.message = action.payload.message;
    if (state.adminProducts && action.payload.productId) {
      state.adminProducts = state.adminProducts.filter((p) => p._id !== action.payload.productId);
    }
  },
  deleteProductFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  updateProductRequest: (state) => { state.isLoading = true; },
  updateProductSuccess: (state, action) => {
    state.isLoading = false;
    state.product = action.payload;
    state.success = true;
  },
  updateProductFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
    state.success = false;
  },

  getSingleProductRequest: (state) => { state.productLoading = true; },
  getSingleProductSuccess: (state, action) => {
    state.productLoading = false;
    state.product = action.payload;
  },
  getSingleProductFailed: (state, action) => {
    state.productLoading = false;
    state.error = action.payload;
  },

  getFeaturedRequest: (state) => { state.isLoading = true; },
  getFeaturedSuccess: (state, action) => {
    state.isLoading = false;
    state.featuredProducts = action.payload;
  },
  getFeaturedFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  getBestSellersRequest: (state) => { state.isLoading = true; },
  getBestSellersSuccess: (state, action) => {
    state.isLoading = false;
    state.bestSellers = action.payload;
  },
  getBestSellersFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  clearErrors: (state) => { state.error = null; },
  clearSuccess: (state) => { state.success = false; },
});
